import { OrmModel, StringField, NumberField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.TIMEZONE)
export default class Timezone extends BaseModel {
  @StringField()
  public id: string

  @StringField()
  public timezone: string

  @NumberField(0)
  public dst: number

  @StringField()
  public area: string
}
